import React, { useState } from 'react'
import "./Classes.css"
import { Link } from 'react-router-dom'
import Footer from '../Footer/Footer'
import NavBar from "../NavBar/NavBar"
import {classes} from "../../Data"


const Classes = () => {
  return (
    <div className='kiga-classes-main'>
      <NavBar/>
    <div className='kiga-classes-section-filter'>
     <div className='kiga-classes-section-filter-title'>
       <p>Filters </p>
     </div>
     <div className='kiga-classes-section-filter-box'>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
       <div className='kiga-classes-section-filter-box-flex'>
        <p>Programs</p>
        <span>{'>'}</span>
       </div>
     </div>
    </div>
    <section className='kiga-classes-section'>
      {
        classes?.map((item,key)=>(
     <div className='kiga-classes-section-box' key={key}>
      <Link to={`/portal/booking/classes/:id`}>
        <div className='kiga-classes-section-box-image'>
          <img src={item?.image}alt='classes'/>
        </div>
      </Link>
      <Link to={`/portal/booking/classes/:id`}>
        <div className='kiga-classes-section-title'>
        <p>{item?.title}</p>
        </div>
      </Link>
      <div className='kiga-classes-section-schedule'>
        <div className='kiga-classes-section-schedule-date'>
          <p>{item?.date}</p>
        </div>
        <div className='kiga-schedule-activity'>
         <p >{item?.activity}</p>
        </div>
      </div>
      <div className='kiga-classes-section-days'>
        {
          item?.day?.map((item,key)=>(
            <p key={key}>
              {item}
            </p>
          ))
        }

      </div>
     </div>
        ))
      }

    </section>
    <Footer/>
    </div>
  )
}

export default Classes